/* Mobile presentation only. Horizon continues to own menus, search, product and cart state. */
(() => {
  const key = Symbol.for('chenly.mobileEdition');
  if (window[key]) return;
  window[key] = true;
  const media = matchMedia('(max-width:600px)');
  const footerRecords = new Map();
  const clones = new Set();
  const inputs = new Map();
  function undo() {
    for (const node of clones) node.remove();
    clones.clear();
    for (const [group, record] of footerRecords) {
      record.marker.replaceWith(record.heading);
      record.details.replaceWith(...record.content.childNodes);
      group.classList.remove('cm-footer-group');
    }
    footerRecords.clear();
    for (const [input, value] of inputs) {
      if (value === null) input.removeAttribute('placeholder');
      else input.setAttribute('placeholder', value);
    }
    inputs.clear();
  }
  function clone(template, target, position = 'append') {
    if (!template || !target) return;
    const node = template.content.firstElementChild.cloneNode(true);
    node.dataset.chenlyMobileClone = '';
    clones.add(node);
    if (position === 'before') target.before(node);
    else target.append(node);
  }
  function apply() {
    undo();
    if (!media.matches) return;
    const source = document.querySelector('[data-chenly-mobile-home]');
    if (source) {
      clone(source.querySelector('[data-mobile-featured]'), document.querySelector('[id$="__product_list_fa6P9H"] .section-resource-list__header'), 'before');
      clone(source.querySelector('[data-mobile-beauty-eyebrow]'), document.querySelector('[id$="__chenly_brand_story"] .text-block.h6'));
      clone(source.querySelector('[data-mobile-beauty]'), document.querySelector('[id$="__chenly_brand_story"] .text-block.h2'));
      clone(source.querySelector('[data-mobile-newsletter]'), document.querySelector('[id$="__chenly_newsletter"] .section-content-wrapper'), 'before');
    }
    const signup = document.querySelector('[id$="__chenly_newsletter"] input[type="email"]');
    if (signup) { inputs.set(signup, signup.getAttribute('placeholder')); signup.setAttribute('placeholder', 'Your email address'); }
    for (const group of document.querySelectorAll('[id$="__footer_m9NzUG"] .footer-content > .group-block')) {
      const heading = group.querySelector('.text-block:has(h3)');
      const content = heading?.parentElement;
      if (!heading || !content) continue;
      const marker = document.createComment('mobile footer heading origin');
      const details = document.createElement('details');
      details.className = 'cm-footer-accordion';
      const summary = document.createElement('summary');
      summary.textContent = heading.textContent.trim();
      const body = document.createElement('div');
      heading.replaceWith(marker);
      for (const child of [...content.children]) body.append(child);
      details.append(summary, body);
      content.append(details);
      group.classList.add('cm-footer-group');
      footerRecords.set(group, {heading, marker, details, content:body});
    }
    enhanceMenu();
  }

  function enhanceMenu() {
    if (!media.matches) return;
    const menu = document.querySelector('#Details-menu-drawer-container .menu-drawer__navigation');
    if (menu && !menu.querySelector('.cm-menu-search')) {
      const heading = document.createElement('div');
      heading.className = 'cm-menu-heading'; heading.textContent = 'Explore CHENLY';
      clones.add(heading); menu.before(heading);
      const label = document.createElement('p');
      label.className = 'cm-menu-label'; label.textContent = 'EXPLORE';
      const nav = document.createElement('nav');
      nav.className = 'cm-menu-links'; nav.setAttribute('aria-label', 'Explore');
      const list = document.createElement('ul');
      const nativeItems = [
        [menu.querySelector('.chenly-shop-drawer ul a'), 'All Jewelry', '/collections/all', false],
        [menu.querySelector('.chenly-shop-explore a'), 'Collections', '/collections', true],
        [menu.querySelector('a.menu-drawer__menu-item--mainlist'), 'Our Story', '/pages/our-story', false],
      ];
      for (const [original, fallbackLabel, fallbackURL, compact] of nativeItems) {
        const li = document.createElement('li'); const a = document.createElement('a');
        let label = original?.textContent.trim() || fallbackLabel;
        if (compact) { label = label.replace(/^Explore\s+/i, ''); label = label.charAt(0).toUpperCase() + label.slice(1); }
        a.textContent = label; a.href = original?.getAttribute('href') || fallbackURL;
        if (original?.hasAttribute('aria-current')) a.setAttribute('aria-current', original.getAttribute('aria-current'));
        li.append(a); list.append(li);
      }
      nav.append(label, list); clones.add(nav); menu.append(nav);
      const search = document.createElement('button');
      search.type = 'button'; search.className = 'cm-menu-search';
      search.textContent = 'Find a piece';
      search.addEventListener('click', () => {
        const drawer = menu.closest('header-drawer');
        const close = drawer?.querySelector('.menu-drawer__close-button');
        close?.click();
        setTimeout(() => {
          const dialog = document.querySelector('#search-modal dialog');
          dialog?.addEventListener('close', () => {
            if (media.matches) requestAnimationFrame(() => document.querySelector('summary[aria-label="Menu"]')?.focus());
          }, {once:true});
          document.querySelector('.header__column--right search-button button')?.click();
        }, 400);
      });
      clones.add(search); menu.append(search);
    }
  }
  let watchedHeader;
  const observer = new MutationObserver(enhanceMenu);
  function watchHeader() {
    const header = document.querySelector('#header-component');
    if (header === watchedHeader) return;
    observer.disconnect(); watchedHeader = header;
    if (header) observer.observe(header, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {apply(); watchHeader();}, {once:true});
  else {apply(); watchHeader();}
  media.addEventListener('change', apply);
  document.addEventListener('shopify:section:load', () => {apply(); watchHeader();});
  document.addEventListener('shopify:section:unload', undo);
})();
